export const GET_ACTION_TYPES = 'GET_ACTION_TYPES';
const SET_ACTION_TYPES = 'SET_ACTION_TYPES';


export const getActionTypes = () => ({
    type: GET_ACTION_TYPES
})

export const setActionTypes = (actions: any) => ({
    type: SET_ACTION_TYPES,
    actions
})

const initialState = {
    actions: null
}

export const actionTypesReducer = (state = initialState, action: any) => {

    switch (action.type) {
        case SET_ACTION_TYPES:
            const { actions } = action;
            return { ...state, actions };
        default:
            return state
    }
}